import Vue from 'vue'
import { APP_INDICE_MENU } from '../pageview/app/constants.js'

const state = {
  dianjingID: 0,
  dianjingIDList: [],
  compared: false,
  compareStart: "",
  compareEnd: "",
  indicesMenu: APP_INDICE_MENU
}

const mutations = {
  SET_COMPARED(state, comparedObj) {
    Vue.set(state, 'compared', comparedObj.compared)
    Vue.set(state, 'compareStart', comparedObj.compStart)
    Vue.set(state, 'compareEnd', comparedObj.compEnd)
  },
  SET_DJID(state, djid) {
    Vue.set(state, 'dianjingID', djid)
  },
  SET_DJID_LIST(state, djidList) {
    Vue.set(state, 'dianjingIDList', djidList)
  }
}

const actions = {
  SET_COMPARED({ state, commit, rootState }, comparedObj) {
    commit('SET_COMPARED', comparedObj)
  },
  SET_DIANJINGID({ state, commit, rootState }, djid) {
    commit('SET_DJID', djid)
  },
  SET_DIANJINGID_LIST({ state, commit, rootState }, djidList) {
    commit('SET_DJID_LIST', djidList)
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/appmodule.js